import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/useT';
import './FinalCTA.css';

export default function FinalCTA() {
  const t = useT();
  const cta = t.finalCta;

  return (
    <section className="final-cta" aria-labelledby="final-cta-heading">
      <div className="container">
        <div className="final-cta__inner">
          <div className="final-cta__bg" aria-hidden="true">
            <div className="final-cta__bg-circle final-cta__bg-circle--1" />
            <div className="final-cta__bg-circle final-cta__bg-circle--2" />
          </div>

          <div className="badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderColor: 'rgba(255,255,255,0.2)' }}>
            {cta.badge}
          </div>

          <h2 id="final-cta-heading" className="final-cta__headline">
            {cta.headline}
          </h2>

          <p className="final-cta__sub">{cta.sub}</p>

          <div className="final-cta__actions">
            <Link to="/contact" className="btn btn-xl" style={{ background: 'white', color: 'var(--color-primary)', fontWeight: 'var(--font-bold)' }}>
              {cta.ctaPrimary}
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M3.5 9h11M10 4.5l4.5 4.5-4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
            <Link to="/features" className="btn btn-xl btn-ghost" style={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}>
              {cta.ctaSecondary}
            </Link>
          </div>

          <div className="final-cta__trust">
            <span>✓ {cta.trust1}</span>
            <span>✓ {cta.trust2}</span>
            <span>✓ {cta.trust3}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
